import { RegionType } from '@wix/shoutout-email-model-v3';
import { getTextSection } from '../get-text';
export const getWixFooterSection = (props) => {
    const region = props.region;
    if (region.type !== RegionType.WixFooter) {
        throw Error('Wix footer must be passed');
    }
    return {
        ...getTextSection({
            ...props,
            region: {
                type: RegionType.Text,
                regionId: region.regionId,
                data: {
                    html: '',
                    systemFontsOnly: true,
                    fonts: [],
                },
            },
        }),
        footerType: region.data.footerType,
    };
};
//# sourceMappingURL=get-wix-footer-section.js.map